import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

export default function SortIcon({ field, currentField, direction }) {
  if (currentField !== field) return null;
  return direction === 'asc' ? (
    <ArrowUp size={14} className="ml-1 inline" />
  ) : (
    <ArrowDown size={14} className="ml-1 inline" />
  );
}

